// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table__body[data-v-2046c57d] {\r\n  width: 100%;\r\n  table-layout: fixed !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
